import React, { useEffect, useState } from "react";
import PaginatedTable from "../common/PaginatedTable";
import DTIPages from "../common/DTIPages";
import { View } from "@instructure/ui-view";
import { Text } from "@instructure/ui-text";
import DtiToolbar from "../common/DtiToolbar";
import DtiKpiGrid from "../common/DtiKpiGrid";
import DtiSectionHeading from "../common/DtiSectionHeading";
import DtiOverviewSkeleton from "../common/DtiSkeleton";
import {
  getJobLCMSInfo,
  getLCMSInfo,
  createJobLCMSInfo,
} from "../api/api";

const KPI_HEADERS = [
  { id: "lcmsSystemName", text: "Tên hệ thống LCMS" },
  { id: "totalLecture", text: "Số bài giảng giáo viên đã tạo" },
  { id: "totalLectureLearner", text: "Số lượt học bài giảng" },
];

export default function LCMSInfo({ iframe = false }) {
  const [data, setData] = useState(null);
  const [isFetching, setIsFetching] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    let intervalId;
    const fetchData = async () => {
      setIsFetching(true);
      try {
        setData(await getLCMSInfo());

        const job = await getJobLCMSInfo();
        if (["starting", "pending"].includes(job?.workflow_state)) {
          setIsLoading(true);
          intervalId = setInterval(async () => {
            const jobStatus = await getJobLCMSInfo();
            if (jobStatus?.workflow_state === "done") {
              setIsLoading(false);
              clearInterval(intervalId);
              setIsFetching(true);
              try {
                setData(await getLCMSInfo());
              } finally {
                setIsFetching(false);
              }
            }
          }, 1000);
        }
      } finally {
        setIsFetching(false);
      }
    };
    fetchData();
    return () => clearInterval(intervalId);
  }, []);

  const handleJob = async () => {
    if (isLoading) return;
    setIsLoading(true);
    await createJobLCMSInfo();
    const intervalId = setInterval(async () => {
      const job = await getJobLCMSInfo();
      if (job?.workflow_state === "done") {
        setIsLoading(false);
        clearInterval(intervalId);
        setIsFetching(true);
        try {
          setData(await getLCMSInfo());
        } finally {
          setIsFetching(false);
        }
      }
    }, 1000);
  };

  const showSkeleton = isFetching || isLoading;

  return (
    <>
      {iframe ? (
        <View as="div" margin="small" textAlign="center">
          <Text size="large">Bạn không được quyền truy cập</Text>
        </View>
      ) : (
        <>
          {showSkeleton ? (
            <DtiOverviewSkeleton kpiCount={3} />
          ) : (
            <>
          <DtiToolbar isLoading={isLoading} onRefresh={handleJob} />

          <DTIPages
            secondPage={
              <>
                <DtiSectionHeading>6.2.1 Tên hệ thống LCMS</DtiSectionHeading>
                <li style={{ marginLeft: '20px' }}>{data?.lcmsSystemName}</li>
                <DtiSectionHeading>6.2.2 Chi tiết thống kê số bài giảng giáo viên đã tạo</DtiSectionHeading>
                <li style={{ marginLeft: '20px' }}>
                  Dạng bài tập: {data?.dataLecture?.totalAssignment}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "title",
                        text: "Tiêu đề",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataLecture?.dataAssignment}
                  perPage={10}
                />
                <li style={{ marginLeft: '20px' }}>
                  Dạng trang: {data?.dataLecture?.totalWiki}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "title",
                        text: "Tiêu đề",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataLecture?.dataWiki}
                  perPage={10}
                />
                <li style={{ marginLeft: '20px' }}>
                  Dạng đề kiểm tra: {data?.dataLecture?.totalQuiz}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "title",
                        text: "Tiêu đề",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataLecture?.dataQuiz}
                  perPage={10}
                />
                <li style={{ marginLeft: '20px' }}>
                  Dạng tập tin: {data?.dataLecture?.totalAttachment}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "filename",
                        text: "Tên tệp",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataLecture?.dataAttachment}
                  perPage={10}
                />
                <li style={{ marginLeft: '20px' }}>
                  Dạng thảo luận: {data?.dataLecture?.totalDiscussion}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "title",
                        text: "Tiêu đề",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataLecture?.dataDiscussion}
                  perPage={10}
                />
                <li style={{ marginLeft: '20px' }}>
                  Dạng URL bên ngoài: {data?.dataLecture?.totalExternalUrl}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "url",
                        text: "Đường dẫn được nhúng",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataLecture?.dataExternalUrl}
                  perPage={10}
                />
                <li style={{ marginLeft: '20px' }}>
                  Dạng công cụ bên ngoài: {data?.dataLecture?.totalExternalTool}
                </li>
                <li style={{ marginLeft: '20px' }}>
                  Thống kê chi tiết:
                </li>
                <PaginatedTable
                  headers={
                    [
                      {
                        id: "url",
                        text: "Đường dẫn được nhúng",
                        width: "20%",
                      },
                      {
                        id: "course_name",
                        text: "Thuộc khóa học",
                        width: "20%",
                      },
                      {
                        id: "term",
                        text: "Niên khóa",
                        width: "20%",
                      },
                      {
                        id: "created_at",
                        text: "Ngày tạo",
                        width: "20%",
                      },
                      {
                        id: "updated_at",
                        text: "Chỉnh sửa gần nhất",
                        width: "20%",
                      },
                    ]
                  }
                  rows={data?.dataLecture?.dataExternalTool}
                  perPage={10}
                />
                <DtiSectionHeading>6.2.3 Chi tiết thống kê số học sinh phát sinh hoạt động học tập</DtiSectionHeading>
                <li style={{ marginLeft: '20px' }}>
                  Số học sinh phát sinh hoạt động học tập: {data?.totalLectureLearner}
                </li>
              </>
            }
            firstPage={
              <DtiKpiGrid
                items={KPI_HEADERS.map(({ id, text }) => ({
                  id,
                  label: text,
                  value: data?.[id],
                }))}
              />
            }
          />
            </>
          )}
        </>
      )}
    </>
  );
}
